import { all, call, put } from 'redux-saga/effects';

import { openModal } from 'store/modals/actions';
import { cancelSubscription } from 'store/subscriptions/actions';
import { checkAllCancelledSubscriptions } from 'store/subscriptions/helpers';

import { sendAnalyticSubscriptionCancelError } from 'services/Analytics';

import { ModalName } from 'modals/types';

import { callErrorCancellingBehaviour } from './callErrorCancellingBehaviour';
import { callSuccessCancellingBehaviour } from './callSuccessCancellingBehaviour';
import { callUnsubscribe } from './callUnsubscribe';
import { pollGetSubscriptions } from './pollGetSubscriptions';

export function* makeSubscriptionCancelling({
    payload: { cancellationCandidates, cancelOfferAbVariant },
}: ReturnType<typeof cancelSubscription>) {
    const successCount = { current: 0 };
    const errorCount = { current: [] };

    yield put(
        openModal(ModalName.WithLoaderModal, {
            title: 'subscription.withLoaderModal.cancellingPlan',
            img: null,
        })
    );

    try {
        yield all(
            cancellationCandidates.map((candidate) => call(callUnsubscribe, candidate, successCount, errorCount))
        );

        successCount.current = 1;
    } catch (error) {
        const [firstSubscription] = cancellationCandidates;

        yield call(sendAnalyticSubscriptionCancelError, firstSubscription.external_id);
    } finally {
        const successTotal = successCount.current;
        const errorTotal = errorCount.current.length;

        if (errorTotal > 0) {
            yield call(callErrorCancellingBehaviour, { errorCount, cancellationCandidates, cancelOfferAbVariant });
        } else if (successTotal > 0) {
            yield call(pollGetSubscriptions, checkAllCancelledSubscriptions(cancellationCandidates));
            yield call(callSuccessCancellingBehaviour, { cancellationCandidates, cancelOfferAbVariant });
        }
    }
}
